/*
  Project: Starter Test
  Author: Michał Strześniewski
 */

import inputs from './modules/inputs';
import slider from './modules/slider';
import menuSearchForm from './modules/menuSearchForm';
import scrollHandler from './modules/scrollHandler';
import map from './modules/map';
import heroEventBackground from './modules/heroEventBackground';
import carousels from './modules/carousels';
import filters from './modules/filters';
import menu from './modules/menu';
import navigation from './modules/navigation';
import socials from './modules/socials';
import cookieNotice from './modules/cookieNotice';
import freshmail from './modules/freshmail';
import partnerPopup from './modules/partnerPopup';
import accessibility from './modules/accessibility';
import allNews from './modules/allNews';

inputs();
slider();
heroEventBackground();
scrollHandler();
menuSearchForm();
map();
carousels();
filters();
menu();
navigation();
socials();
cookieNotice();
freshmail();
partnerPopup();
accessibility();
allNews();


// WEBPACK FOOTER //
// ./wp/wp-content/themes/eco-chisel/src/scripts/app.js